// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2Urpb","active":"Pagination_active__12FXg"};